import { eventLogProducer } from '@/lib/event-logger'
import { createResource, useResource } from '@/lib/i18n'
import { Action } from '@@/action_pb'
import { randomSort } from '@/lib/utils'
import { NextPage } from 'next'
import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'
import QuestionList from './common/question-list'

const resource = createResource({
  en: {
    frequently: 'Frequently Asked Questions',
    hotPost: 'Hot Related Posts',
    knowMore: 'Know More >',
  },
  id: {
    frequently: 'Frequently Asked Questions',
    hotPost: 'Hot Related Posts',
    knowMore: 'Know More >',
  },
})

type IParams = {
  blogData: any[]
  categoryList?: any[]
}

const MainFAQ: NextPage<IParams> = (params: IParams) => {
  const { t } = useResource(resource)
  const blogData = params.blogData.sort(randomSort).slice(0, 10)
  const eventClick = () => {
    eventLogProducer.push({
      action: Action.KNOWMORELINKCLICK,
    })
  }
  const eventClickPost = (url, id) => {
    eventLogProducer.push({
      action: Action.POSTSDETAILLINKCLICK,
      extra: { targetUrl: url, articleId: `${id}` },
    })
  }
  return (
    <MainFAQStyle>
      <section className="container">
        <section className="frequently">
          <h2>{t('frequently')}</h2>
          <QuestionList categoryList={params.categoryList} />
        </section>
        <section className="hot-post">
          <h2>{t('hotPost')}</h2>
          <div className="hot-article">
            {blogData.slice(0, 4)?.map((item) => {
              return (
                <Link href={`/education/${item.slug}`} key={item.id}>
                  <a
                    target="_blank"
                    aria-label={item?.title?.rendered}
                    className="article-item"
                    onClick={() => {
                      eventClickPost(`/education/${item.slug}`, item.id)
                    }}
                  >
                    <div dangerouslySetInnerHTML={{ __html: item?.title?.rendered }}></div>
                  </a>
                </Link>
              )
            })}
            <Link href={`/education`}>
              <a className="know-more" onClick={eventClick}>
                {t('knowMore')}
              </a>
            </Link>
          </div>
        </section>
      </section>
    </MainFAQStyle>
  )
}

export default MainFAQ

const MainFAQStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 62px;
    .container {
      width: 100%;
      margin: 0 auto;
      padding: 0 24px;
      h2 {
        font-size: 24px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 28px;
        text-align: center;
      }
      .hot-post {
        padding-top: 40px;
        .hot-article {
          border-radius: 8px;
          border: 1px solid #cccccc;
          .article-item {
            display: block;
            text-decoration: underline;
            font-size: 14px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            color: #212121;
            line-height: 20px;
            padding: 16px 0 0 16px;
          }
          .know-more {
            display: block;
            font-size: 14px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            color: #1cc812;
            line-height: 20px;
            padding: 16px 0 16px 16px;
          }
        }
        .container-bca {
          width: 100% !important;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 72px auto 0;
    .container {
      width: 100%;
      max-width: 1440px;
      margin: 0 auto;
      padding: 0 150px;
      display: flex;
      justify-content: space-between;
      h2 {
        font-size: 28px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 36px;
        padding-bottom: 20px;
      }
    }
    .hot-article {
      width: 484px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #cccccc;
      .article-item {
        display: block;
        text-decoration: underline;
        font-size: 16px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: #212121;
        line-height: 20px;
        padding: 24px 0 0 24px;
      }
      .know-more {
        display: block;
        font-size: 16px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: #1cc812;
        line-height: 20px;
        padding: 24px 0 24px 24px;
      }
    }
    .container-bca {
      width: 484px !important;
    }
  }
`
